module.exports = __webpack_public_path__ + "static/media/inspiration-add@shortened.a9b60a58.gif";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/inspiration-add@shortened.gif
// module id = 205
// module chunks = 0